import { SettingOutlined } from '@ant-design/icons'
import {
  Button,
  Popconfirm,
  Popover,
  Space,
  TableColumnType,
  Tag,
  Tooltip,
} from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { StateSwitch } from '../../compnents/widgets/StateSwitch'
import { DateTimeFormatSimple } from '../../models/datetime'
import {
  getTenantCategoryName,
  getTeantTypeName,
  Tenant,
} from '../../models/tenant'
import { ThemeData } from '../../theme/ThemeContext'

export const columns = (
  onClick: (
    type: 'settings' | 'toggle' | 'detail' | 'openReplaceMake',
    tenant: Tenant
  ) => void,
  startIndex: number,
  theme: ThemeData
): TableColumnType<Tenant>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },

    {
      title: '机构名称',
      key: 'name',
      align: 'center',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <Popover
            trigger='hover'
            placement='topLeft'
            content={
              <>
                <div
                  style={{
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <i
                    style={{
                      width: 'auto',
                      height: '100%',
                      fontStyle: 'normal',
                      marginRight: '10px',
                    }}
                  >
                    {t.name}
                  </i>
                  {t?.trialFlag == 1 && (
                    <div
                      style={{
                        width: '24px',
                        height: '24px',
                        background: '#FF8345',
                        color: '#fff',
                        fontSize: '14px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      试
                    </div>
                  )}
                </div>
              </>
            }
          >
            <div
              style={{
                width: 220,
                margin: 'auto',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',

              }}
            >
              <span
                style={{
                  width: 'auto',
                  height: '100%',
                  fontStyle: 'normal',
                  marginRight: '10px',
                }}
              >
                {t.name} {t?.trialFlag == 1 && (
                  <span
                    style={{
                      width: '24px',
                      height: '24px',
                      background: '#FF8345',
                      color: '#fff',
                      fontSize: '14px',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    试
                  </span>
                )}
              </span>

            </div>
          </Popover>
        )
      },
    },
    {
      title: '机构类别',
      key: 'tenantCategory',
      align: 'center',
      width: '5rem',
      render: (_, t) => getTenantCategoryName(t.tenantCategory),
    },
    {
      title: '机构类型',
      dataIndex: 'tenantType',
      key: 'tenantType',
      align: 'center',
      width: '5rem',
      ellipsis: true,
    },
    {
      title: '版本名称',
      key: 'versionName',
      dataIndex: 'versionName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: function element(_, t) {
        return (
          <Space>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ marginRight: '10px' }}>{t?.versionName}</span>
            </div>
          </Space>
        )
      },
    },
    {
      title: '标签',
      key: 'labelIds',
      align: 'center',
      render: function element(_, t) {
        return (
          <Space>
            {t.labelList.map((item: any) => {
              return (
                <Tooltip key={item.id} placement='top' title={item.name}>
                  <Tag
                    color={item.backgroundColor}
                    style={{ color: `${item.fontColor}` }}
                  >
                    {item.headName}
                  </Tag>
                </Tooltip>
              )
            })}
          </Space>
        )
      },
    },
    {
      title: '所属平台',
      align: 'center',
      dataIndex: 'platformName',
      ellipsis: true,
    },

    {
      title: '地址',
      key: 'address',
      align: 'left',
      ellipsis: true,
      dataIndex: 'address',
    },
    {
      title: '开通时间',
      key: 'createTime',
      align: 'center',
      width: '8rem',
      render: (_, t) => t.createTime?.split(' ')?.[0],
      sorter: true,
    },
    {
      title: '终止时间',
      key: 'endTime',
      align: 'center',
      width: '8rem',
      render: (_, t) => {
        return t.endTime?.split(' ')?.[0]
      },
      sorter: true,
    },
    {
      title: '服务状态',
      key: 'status',
      align: 'center',
      width: '8rem',
      render: function Status(_, t): ReactElement {
        const active = t.status === 1
        return (
          <Popconfirm
            title={active ? '是否确认注销' : '是否确认开启'}
            onConfirm={() => onClick('toggle', t)}
            okText='确认'
            cancelText='取消'
          >
            <div>
              <StateSwitch value={active} />
            </div>
          </Popconfirm>
        )
      },
    },
    {
      title: '操作',
      key: 'action',
      align: 'center',
      width: '10em',
      render: function ActionBar(_, t): ReactElement {
        return (
          <Space>
            <a
              onClick={() => onClick('settings', t)}
              style={{ color: theme.tc2 }}
            >
              <SettingOutlined
                style={{
                  color: theme.c1,
                  marginRight: 4,
                  fontSize: '0.875rem',
                }}
              />
              设置
            </a>
            <a onClick={() => onClick('detail', t)}>查看详情 </a>
          </Space>
        )
      },
    },
  ]
}

export const orderColumns = (
  onClick: (t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '机构ID',
      key: 'id',
      align: 'center',
      width: '6rem',
      dataIndex: 'id',
    },
    {
      title: '机构名称',
      dataIndex: 'tenantName',
      key: 'tenantName',
      width: '12rem',
      align: 'center',
      ellipsis: true,
      render: function tenantName(_, t) {
        return t?.tenantName ? (
          <Tooltip title={t.tenantName}>
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                textAlign: 'center',
              }}
            >
              {t.tenantName}
            </div>
          </Tooltip>
        ) : (
          '-'
        )
      },
    },
    {
      title: '所在区域',
      dataIndex: 'region',
      key: 'region',
      width: '8rem',
      align: 'center',
      ellipsis: true,
      render: function region(_, t) {
        return t?.region ? (
          <Tooltip title={t.region}>
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                textAlign: 'center',
              }}
            >
              {t.region}
            </div>
          </Tooltip>
        ) : (
          '-'
        )
      },
    },
    {
      title: '服务类型',
      key: 'serverName',
      dataIndex: 'serverName',
      width: '8rem',
      align: 'center',
      ellipsis: true,
    },
    {
      title: '服务费用',
      dataIndex: 'amount',
      key: 'amount',
      width: '6rem',
      align: 'center',
      ellipsis: true,
      render: (_, t) => {
        return t.amount.toFixed(2)
      },
    },
    {
      title: '到期日期',
      dataIndex: 'serveEndTime',
      key: 'serveEndTime',
      width: '6rem',
      align: 'center',
      ellipsis: true,
      render: (_, t) => {
        return t.serveEndTime
          ? moment(t.serveEndTime)?.format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '备注',
      key: 'remark',
      dataIndex: 'remark',
      align: 'center',
      ellipsis: true,
      width: '10rem',
      render: function RemarkText(_, t) {
        return t?.remark ? (
          <Tooltip title={t.remark}>
            <div
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'normal',
                textAlign: 'left',
                fontSize: '0.875rem',
                lineHeight: '1.4',
                maxHeight: '2.8rem',
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
              }}
            >
              {t.remark}
            </div>
          </Tooltip>
        ) : (
          <div style={{ textAlign: 'center' }}>-</div>
        )
      },
    },
    {
      title: '状态',
      key: 'status',
      dataIndex: 'status',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: function StatusText(_, t) {
        const statusText = t.status == 0 ? '已过期' : '有效'
        return (
          <span style={{ color: t.status == 0 ? '#ff4d4f' : 'inherit' }}>
            {statusText}
          </span>
        )
      },
    }
  ]
}
